import React from 'react';
import { Badge } from './ui/badge';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqs } from '../data/mock';

const FAQ = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <Badge className="mb-4 bg-[#F5C842]/20 text-[#8B0000] border-[#F5C842]/30">
            FAQ
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Pertanyaan yang <span className="text-[#8B0000]">Sering Diajukan</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Temukan jawaban untuk pertanyaan umum seputar paket umroh kami
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="border-2 border-gray-100 rounded-2xl px-6 hover:border-[#F5C842] transition-colors data-[state=open]:border-[#8B0000] data-[state=open]:shadow-lg"
              >
                <AccordionTrigger className="text-left text-lg font-semibold text-gray-900 hover:text-[#8B0000] py-6 hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* Additional Help */}
          <div className="mt-12 text-center p-8 bg-gradient-to-r from-gray-50 to-white rounded-2xl border-2 border-gray-100">
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Masih Ada Pertanyaan?
            </h3>
            <p className="text-gray-600 mb-4">
              Tim kami siap membantu menjawab semua pertanyaan Anda
            </p>
            <a 
              href="#contact"
              className="inline-block px-8 py-3 bg-[#8B0000] hover:bg-[#A52A2A] text-white font-medium rounded-lg transition-colors"
            >
              Hubungi Kami Sekarang
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
